// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 120) return "content/plugin-system-audit/9f754078d91b8fd3f12366133ff7a029.js";
	if (chunkId === 856) return "content/plugin-system-audit/f7c14393e79268aeea4119023282f138.js";
	if (chunkId === 781) return "content/plugin-system-audit/fb4291a3349f69a9f6d680adf4c8dcd9.js";
	// return url for filenames based on template
	return undefined;
};